<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-10 12:38:40
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-06 09:16:31
 * @FilePath: \Home\Transfor-website\src\views\pc\Community\Group.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="Group">
      <div class="Group-Y">
        <div class="Group-W">
          <img src="../../../assets/pc/Collectove/Cillectove5.png" />
          <div class="Group-Top">
            <p>
              <span>{{ $t("collective.Join") }}</span
              ><span>{{ $t("collective.Transformers") }}</span
              ><span>{{ $t("collective.collective") }}</span>
            </p>
            <p>{{ $t("collective.Let") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="Group--Bottom">
      <div class="Group_Bottom-W">
        <div class="Group-Center">
          <ul class="clearfix">
            <li v-for="(item, index) in list" :key="index">
              <p><img :src="item.ImgUrl" /></p>
              <p>{{ item.name }}</p>
              <p><span></span><span></span></p>
              <p>{{ item.Text }}</p>
            </li>
          </ul>
          <div class="Group-Bottom">
            <p><span></span>Join us</p>
            <p>
              <span>{{ $t("collective.Post") }}</span
              ><button @click="Masg">Apply to join</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "If you focus on blockchain development",
          Text: "You can help the Transformers optimize security bugs, algorithm protocols, application tools, etc., if adopted will receive a generous reward.",
          ImgUrl: require("../../../assets/pc/Collectove/cillectove13.png"),
        },
        {
          name: "If you are good at community operation",
          Text: "You can help the Transformers establish a global community and active community members; if the community data meets the standard, you will receive a stable allowance.",
          ImgUrl: require("../../../assets/pc/Collectove/cillectove14.png"),
        },
        {
          name: "If you are good at creating content",
          Text: "Can provide unique text content or video creation about the Transformers to the global audience. If published, there will be a generous reward.",
          ImgUrl: require("../../../assets/pc/Collectove/cillectove15.png"),
        },
        {
          name: "If you can develop creative ideas for Transformers",
          Text: "You will receive a generous reward if executed.",
          ImgUrl: require("../../../assets/pc/Collectove/cillectove12.png"),
        },
      ],
      W: document.body.clientWidth + "px",
    };
  },

  mounted() {},

  methods: {
     Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "HarmonyOS Sans-Black";
  // src: url("./Roboto-Black.ttf");
  font-weight: normal;
  font-style: normal;
}
.Group {
  width: 100%;
  // background: url("../../../assets/pc/Collectove/Cillectove3.png") no-repeat;
  // background-size: 100% !important;
  // height: 900px;
  // background-attachment: fixed;
  background: #f4f4f4;
  .Group-Y {
    // background: url("../../../assets/pc/Collectove/Cillectove4.png") no-repeat;
    // background-size: 100% !important;
    // height: 900px;
  }
  .Group-W {
    width: 1320px;
    margin: 0 auto;
    padding: 209px 0 245px 0;
    position: relative;
    text-align: center;
    background: #f4f4f4;
    img {
      width: 245px;
      height: 280px;
      position: absolute;
      top: 233px;
      left: -325px;
    }
    .Group-Top {
      p:nth-child(1) {
        width: 744px;
        font-size: 80px;
        font-family: HarmonyOS Sans-Black;
        font-weight: 900;
        color: #141414;
        line-height: 95px;
        margin: 0 auto;
        span:nth-child(2) {
          color: #cf61dc;
        }
      }
      p:nth-child(2) {
        width: 544px;
        font-size: 18px;
        font-family: HarmonyOS Sans-Regular;
        font-weight: 400;
        color: #141414;
        line-height: 28px;
        margin-top: 24px !important;
        margin: 0 auto;
      }
    }
  }
}
.Group--Bottom {
  width: 100%;
  background: #f4f4f4;
  padding-bottom: 193px;
  .Group_Bottom-W {
    width: 1320px;
    height: 1149px;
    margin: 0 auto;
    position: relative;
    background: #f4f4f4;
    min-width: 1320px;
    .Group-Center {
      position: absolute;
      top: -240px;
      left: 0;
      margin-top: 179px;
      padding-bottom: 249px;
      background: #f4f4f4;
      ul {
        width: 100%;
        li {
          width: 650px;
          height: 370px;
          padding: 24px 0 147px 30px;
          box-sizing: border-box;
          float: left;
          p:nth-child(1) {
            img {
              width: 80px;
              height: 80px;
            }
            margin-bottom: 28px;
          }
          p:nth-child(2) {
            // width: 226px;
            font-size: 18px;
            font-family: HarmonyOS Sans-Black;
            font-weight: 900;
            color: #ffffff;
            line-height: 25px;
          }
          p:nth-child(3) {
            width: 15px;
            height: 21px;
            margin: 21px 0 0 0;
            span {
              display: inline-block;
              width: 3px;
              height: 8px;
              background: #cf61dc;
            }
            span:nth-child(2) {
              margin-left: 3px;
            }
          }
          p:nth-child(4) {
            // width: 255px;
            padding-right: 50px;
            font-size: 16px;
            font-family: HarmonyOS Sans-Medium;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.699999988079071);
            line-height: 24px;
          }
        }
        li:hover {
          background: #333333 !important;
        }
        li:nth-child(1) {
          background: #141414;
          margin-right: 10px;
        }
        li:nth-child(2) {
          background: #141414;
          margin-left: 10px;
        }
        li:nth-child(3) {
          background: #141414;
          margin-top: 20px;
        }
        li:nth-child(4) {
          background: #141414;
          margin: 20px 0 0 20px;
          p:nth-child(1) {
            width: 361px;
          }
        }
      }
      .Group-Bottom {
        width: 100%;
        height: 354px;
        background: url("../../../assets/pc/Collectove/Cillectove7.png")
          no-repeat;
        background-size: 100% !important;
        padding: 35px 50px 130px 50px;
        margin-top: 40px;
        // margin-bottom: 249px;
        p:nth-child(1) {
          span:nth-child(1) {
            display: inline-block;
            width: 60px;
            height: 4px;
            background: #ffffff;
            margin-right: 30px;
            margin-bottom: 5px;
          }
          font-size: 24px;
          font-family: HarmonyOS Sans-Black;
          font-weight: 900;
          color: #ffffff;
          line-height: 34px;
          margin-bottom: 21px;
        }
        p:nth-child(2) {
          position: relative;
          span {
            display: inline-block;
            width: 1022px;
            font-size: 60px;
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans, "Segoe UI",
            //   "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
            //   "Droid Sans", "Helvetica Neue", sans-serif;
            font-family: HarmonyOS Sans-Black;
            font-weight: 900;
            color: #ffffff;
            line-height: 70px;
          }
          button {
            width: 180px;
            height: 50px;
            background: rgba(255, 255, 255, 0.3499999940395355);
            border-radius: 25px 25px 25px 25px;
            border: 2px solid #ffffff;
            font-size: 20px;
            font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 28px;
            position: absolute;
            top: 55px;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
